import type { Registry } from "@kilat/contracts/tld-pricing";
import { useMutation } from "@tanstack/react-query";
import { setTldRegistry } from "../api";
import { staffKeys } from "../queries";

export const useSetTldRegistry = (tldId: string) =>
  useMutation({
    mutationFn: (registry: Registry) => setTldRegistry(tldId, { registry }),
    onSuccess: (_data, _registry, _result, { client }) => {
      void client.invalidateQueries({ queryKey: staffKeys.tldPricing() });
    },
  });
